export default __webpack_public_path__ + "static/media/noAnnouncment.a6e3b242.png";